import {IPropertyDetail} from "../types/IPropertyDetail";
import {IRecommendedProperty} from "../types/IRecommendedProperty";

export function isPropertyDetail(property: IPropertyDetail | IRecommendedProperty): property is IPropertyDetail {
    return "currency" in property.offer;
}
import {IPropertyDetail} from "../types/IPropertyDetail";
import {IRecommendedProperty} from "../types/IRecommendedProperty";

export function isPropertyDetail(property: IPropertyDetail | IRecommendedProperty): property is IPropertyDetail {
    return "currency" in property.offer;
}
